import { render, staticRenderFns } from "./StaffAbsenceReport.vue?vue&type=template&id=58241083"
import script from "./StaffAbsenceReport.vue?vue&type=script&lang=js"
export * from "./StaffAbsenceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports